import React from "react";
import AllPurchasePriceHistories from "./PurchasePriceHistoryModule/AllPurchasePriceHistory";

const PurchasePriceHistories = () => {
  return (
    <div>
      <AllPurchasePriceHistories />
    </div>
  );
};

export default PurchasePriceHistories;
